import { render } from "./ModelPerformanceChip.vue?vue&type=template&id=21818bfa"
import script from "./ModelPerformanceChip.vue?vue&type=script&lang=js"
export * from "./ModelPerformanceChip.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__